const FETCH_CONTEST = 'contest/FETCH_CONTEST';

const POST_CONTEST_COMPLETE = 'contest/POST_CONTEST_COMPLETE';

const FETCH_CONTEST_EVENT = 'contest/FETCH_CONTEST_EVENT';

const FETCH_CONTEST_MY_STORY = 'contest/FETCH_CONTEST_MY_STORY';

const FETCH_CONTEST_STORY = 'contest/FETCH_CONTEST_STORY';

const POST_CONTEST_STORY_VOTE = 'contest/POST_CONTEST_STORY_VOTE';

const FETCH_CONTEST_RANKING = 'contest/FETCH_CONTEST_RANKING';

export default {
  FETCH_CONTEST,
  POST_CONTEST_COMPLETE,
  FETCH_CONTEST_EVENT,
  FETCH_CONTEST_MY_STORY,
  FETCH_CONTEST_STORY,
  POST_CONTEST_STORY_VOTE,
  FETCH_CONTEST_RANKING,
};



// WEBPACK FOOTER //
// ./src/app/redux/events/contest/types.js